export let closeTooltip = "nnsi3c";
export default {closeTooltip};